import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import LogoHorizontal from '../../assets/images/9jaPay Logo_Horizontal.svg';
import Logo from '../../assets/images/logo-square.svg';

export default function MinimalNavbar() {
  const { pathname } = useLocation();
  const isAuthSubPath = pathname.startsWith('/auth') && pathname !== '/auth';

  if (isAuthSubPath) {
    return (
      <Box
        bg="neutral.100"
        borderBottom="1px solid"
        borderColor="ash.200"
        data-testid="homepage-navbar"
      >
        <Flex align="center" gap={6} mx="auto" py={3} px={{ base: 4, md: 6 }}>
          <Link as={RouterLink} to="/" data-testid="homepage-link">
            <Image
              src={Logo}
              width="28px"
              height="28px"
              data-testid="header-image"
            />
          </Link>
          <Box w="1px" h="20px" bg="ash.300" />
          <Text
            fontSize="0.75rem"
            fontWeight={500}
            letterSpacing="0.8px"
            textTransform="uppercase"
            color="richBlack.200"
            data-testid="business-account-label"
          >
            Business Account
          </Text>
        </Flex>
      </Box>
    );
  }

  const isLogoHorizontalPath = pathname === '/' || pathname === '/auth';

  return (
    <Box
      bg="neutral.100"
      borderStyle="solid"
      borderColor="ash.200"
      data-testid="homepage-navbar"
    >
      <Flex
        align="center"
        justify="space-between"
        minH="80px"
        mx="auto"
        py={{ base: 2 }}
        px={{ base: 5, md: '44px' }}
      >
        <Link as={RouterLink} to="/" data-testid="homepage-link">
          <Image
            src={isLogoHorizontalPath ? LogoHorizontal : Logo}
            width={isLogoHorizontalPath ? '132px' : '48px'}
            height={isLogoHorizontalPath ? '32px' : '48px'}
            data-testid="header-image"
          />
        </Link>
      </Flex>
    </Box>
  );
}
